
<div class="w-full flex flex-col justify-center items-center bg-themeComponentBg-light px-5 lg:px-0 font-rubik">
  <div class="solution-html-container font-rubik w-full max-w-992">
    <h2 class="solution-title">{{ getSolutionTitle() }}</h2>
    <div class="solution-content" v-html="solution.html_content"></div>
  </div>
</div>
